import { put, call, select } from "redux-saga/effects";
import { Creators as DadosCadastraisActions } from "../ducks/dadosCadastrais";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as LoadingActions } from "../ducks/loading";
import api from "../../services/api";

export function* searchDados({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    // SE A BUSCA FOR POR CPF
    if (payload.target === "cpf") {
      if (payload.dado) {
        let cpf = payload.dado
          .replace(/\./g, "")
          .replace(/-/g, "")
          .replace("/", "");
        const { data } = yield call(
          api.get,
          `/pesquisador/dados-cadastrais/cpf/${cpf}`
        );
        yield put(DadosCadastraisActions.searchDadosSuccess(data));
      } else {
        yield put(ErrorActions.openError("Preencha o campo CPF."));
      }
    }
    // SE A BUSCA FOR POR CNPJ
    if (payload.target === "cnpj") {
      if (payload.dado) {
        let cnpj = payload.dado.replace(/[^\d]/g, "").replace("/", "");
        const { data } = yield call(
          api.get,
          `/pesquisador/dados-cadastrais/cnpj/${cnpj}`
        );
        yield put(DadosCadastraisActions.searchDadosSuccess(data));
      } else {
        yield put(ErrorActions.openError("Preencha o campo CNPJ."));
      }
    }
    // SE A BUSCA FOR POR ENDEREÇO
    if (payload.target === "endereco") {
      function removeAcento(text) {
        text = text.toLowerCase();
        text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
        text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
        text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
        text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
        text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
        text = text.replace(new RegExp("[Ç]", "gi"), "c");
        return text;
      }

      if (payload.dado) {
        const { data } = yield call(
          api.get,
          `/pesquisador/dados-cadastrais/address?address=${removeAcento(
            payload.dado.endereco
          )}&number=${payload.dado.numero}&city=${removeAcento(
            payload.dado.cidade
          )}&uf=${payload.dado.estado}`
        );
        yield put(DadosCadastraisActions.searchDadosSuccess(data));
      } else {
        yield put(ErrorActions.openError("Preencha todos os campos."));
      }
    }
    // SE A BUSCA FOR POR CEP
    if (payload.target === "cep") {
      if (payload.dado) {
        const { data } = yield call(
          api.get,
          `/pesquisador/dados-cadastrais/zipcode?zipcode=${payload.dado.cep}&number=${payload.dado.numero}`
        );
        yield put(DadosCadastraisActions.searchDadosSuccess(data));
      } else {
        yield put(ErrorActions.openError("Preencha o campo CEP."));
      }
    }
    // SE A BUSCA FOR POR TELEFONE
    if (payload.target === "telefone") {
      if (payload.dado) {
        const { data } = yield call(
          api.get,
          `/pesquisador/dados-cadastrais/telephone?ddd=${payload.dado.ddd}&number=${payload.dado.number}`
        );
        yield put(DadosCadastraisActions.searchDadosSuccess(data));
      } else {
        yield put(ErrorActions.openError("Preencha todos os campos"));
      }
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* searchDadosTab({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    // SE A BUSCA FOR POR CPF
    if (payload.target === "cpf") {
      if (payload.dado) {
        let cpf = payload.dado
          .replace(/\./g, "")
          .replace(/-/g, "")
          .replace("/", "");
        const { data } = yield call(
          api.get,
          `/pesquisador/dados-cadastrais/cpf/${cpf}`
        );
        const { dataDadosArray } = yield select(state => state.dadosCadastrais);
        let pivot = [];

        if (
          dataDadosArray.find(
            data =>
              data.cpf
                .replace(/\./g, "")
                .replace(/-/g, "")
                .replace("/", "") === cpf
          )
        ) {
          pivot = [...dataDadosArray];
        } else {
          pivot = [...dataDadosArray, data];
        }
        yield put(DadosCadastraisActions.searchDadosTabSuccess(pivot));
      } else {
        yield put(ErrorActions.openError("Preencha o campo CPF."));
      }
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* searchDadosCnpjTab({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    // SE A BUSCA FOR POR CNPJ
    if (payload.target === "cnpj") {
      if (payload.dado) {
        let cnpj = payload.dado
          .replace(/\./g, "")
          .replace(/-/g, "")
          .replace("/", "");
        const { data } = yield call(
          api.get,
          `/pesquisador/dados-cadastrais/cnpj/${cnpj}`
        );
        const { dataDadosArrayCnpj } = yield select(
          state => state.dadosCadastrais
        );
        let pivot = [];

        if (
          dataDadosArrayCnpj.find(
            data =>
              data.cnpj
                .replace(/\./g, "")
                .replace(/-/g, "")
                .replace("/", "") === cnpj
          )
        ) {
          pivot = [...dataDadosArrayCnpj];
        } else {
          pivot = [...dataDadosArrayCnpj, data];
        }
        yield put(DadosCadastraisActions.searchDadosCnpjTabSuccess(pivot));
      } else {
        yield put(ErrorActions.openError("Preencha o campo CNPJ."));
      }
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* searchDadosRelacionadasTab({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    let cpf = payload.dado
      .replace(/\./g, "")
      .replace(/-/g, "")
      .replace("/", "");
    const { data } = yield call(
      api.get,
      `/pesquisador/dados-cadastrais/cpf/${cpf}/relacionados`
    );
    const { dataDadosArrayRelacionadas } = yield select(
      state => state.dadosCadastrais
    );
    let pivot = [];
    if (
      dataDadosArrayRelacionadas.find(
        data =>
          data.cpf
            .replace(/\./g, "")
            .replace(/-/g, "")
            .replace("/", "") === cpf
      )
    ) {
      pivot = [...dataDadosArrayRelacionadas];
    } else {
      pivot = [
        ...dataDadosArrayRelacionadas,
        {
          cpf: cpf,
          relacionadas: data
        }
      ];
    }
    yield put(DadosCadastraisActions.searchDadosRelacionadasTabSuccess(pivot));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/dadosCadastrais.js